"use client";

import { Box, Button, colors, Typography } from "@mui/material";
import { useRouter } from "@bprogress/next/app";
import { CloudCog, RefreshCw } from "lucide-react";

export default function VideoProcessingNotice() {
    const router = useRouter();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1.5,
            p: 4,
            mt: 2,
            bgcolor: colors.grey[50],
            borderRadius: 2,
            border: '1px dashed',
            borderColor: colors.grey[300]
        }}>
            <CloudCog size={64} color={colors.blue[600]} />
            <Typography variant="h6" component="p">ویدیو در حال آماده‌سازی است</Typography>
            <Typography variant="body2" color="text.secondary">
                سرور در حال پردازش ویدیو است. چند دقیقه دیگر دوباره تست کنید.
            </Typography>
            <Button
                variant="outlined"
                color="primary"
                endIcon={<RefreshCw size={16} />}
                onClick={() => router.refresh()}
                sx={{
                    mt: 2
                }}
            >
                تازه‌سازی صفحه
            </Button>
        </Box>
    );
}
